module.exports = __webpack_public_path__ + "static/media/lefta.afe6b501.PNG";